import clsx from 'clsx';
import React from 'react';

const ArrowDownIcon = ({ className, fill, width, height }) => (
    <svg className={clsx('icon', 'arrow-down-icon', className)} width={width} height={height} viewBox="0 0 14 7">
        <path
            fill={fill}
            d="m 12.709991,0.16355293 a 0.81504342,0.8150831 0 0 1 1.12106,0.13601387 0.76304065,0.7630778 0 0 1 -0.140008,1.0921114 L 7.4907132,6.8362333 a 0.81804358,0.81808341 0 0 1 -0.9820523,0 L 0.30833064,1.3916782 A 0.76304065,0.7630778 0 0 1 0.16932323,0.2995668 0.81504342,0.8150831 0 0 1 1.2903829,0.16355293 L 7.0006871,5.2370703 Z"
        />
    </svg>
);

export default ArrowDownIcon;
